import { motion } from 'framer-motion';
import { styled } from 'styled-components';

export const Wrapper = styled(motion.div)`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100dvh;
    z-index: 9999;

    display: flex;
    align-items: center;
    justify-content: center;

    padding: 20px;
`;

export const Card = styled(motion.div)`
    position: relative;
    z-index: 1;
    max-width: 540px;
    width: 100%;
    background: linear-gradient(134deg, #191727 30.55%, #351b48 103.27%);
    border-radius: 30px;
    overflow: hidden;
`;

export const Backdrop = styled.div`
    position: absolute;
    inset: 0;
    background: rgba(9, 7, 25, 0.8);
    z-index: 0;
`;

export const Banner = styled.div`
    width: 100%;
    height: 180px;
    background: linear-gradient(180deg, #2f2e47 0%, #1f1c36 100%);

    display: flex;
    align-items: center;
    justify-content: center;

    overflow: hidden;
    position: relative;

    img {
        width: 100%;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        height: 309px;
    }
`;

export const Content = styled.div`
    padding: 24px 20px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;

    gap: 15px;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        padding: 32px;
        gap: 23px;
    }
`;

export const Title = styled.div`
    font-size: 24px;
    font-weight: 700;
    line-height: 120%;
    letter-spacing: -1.08px;

    display: flex;
    align-items: center;
    gap: 10px;

    span {
        font-size: 22px;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: 36px;
        gap: 20px;

        span {
            font-size: 32px;
        }
    }
`;

export const Text = styled.div`
    font-size: 14px;
    font-weight: 400;
    line-height: 120%;
    letter-spacing: -0.54px;
    max-width: 440px;
    color: rgba(255, 255, 255, 0.5);

    display: flex;
    flex-direction: column;
    gap: 6px;

    margin-bottom: 10px;

    span {
        color: #fff;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: 18px;
        gap: 10px;
    }
`;

export const Buttons = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const CloseButtonWrapper = styled.div`
    position: absolute;
    top: 15px;
    right: 15px;
    z-index: 1;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        top: 20px;
        right: 20px;
    }
`;

export const YatWrapper = styled.div`
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

export const YatChip = styled.div`
    position: relative;
    z-index: 2;
    transform: rotate(-14.068deg);
    box-shadow: 0px 0px 27.571px rgba(231, 2, 85, 0.6);
    border-radius: 100px;
`;

export const YatLabel = styled.div`
    color: rgba(255, 255, 255, 0.05);
    text-align: center;
    font-size: 58px;
    font-weight: 900;
    line-height: 80%;
    letter-spacing: -6.106px;
    text-transform: uppercase;

    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 0;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: 76px;
    }
`;

///
/// Showcase

export const YatBoxWrapper = styled.div`
    padding: 4px;
    width: 100%;
    border-radius: 10px;
    background-color: rgb(255, 255, 255, 0.1);
`;

export const YatBox = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    aspect-ratio: 1 / 1;
    border-radius: 10px;
    background: linear-gradient(107deg, #18171c 35.22%, #241d56 76.66%);
`;

export const RhythmWrapper = styled.div`
    display: grid;
    grid-auto-flow: column;
    align-items: center;
    font-size: 28px;

    @media (min-width: 768px) {
        font-size: 40px;
    }
`;
